<template>
  <div class="animated fadeIn">
    <b-card border-variant="primary">
      <template slot="header">
        <i class='fa fa-align-justify'></i> WSFinder & WMDS Detect
      </template>

      <!-- detail search start -->
      <b-card v-show="so.adv">
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="opt_date"> Installed_at
                <b-button size="sm" variant="info" @click="set_sd('')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="opt_version">Version</label>
              <br>
              <v-select :disabled="action_list.length == 0" label="Action" v-model="so.opt['action']" :options="action_list"></v-select>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="opt_type">Solution</label>
              <br>
              <v-select label="Action" v-model="so.opt['type']" :options="['wsfinder', 'wmds']"></v-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="opt_target">Target</label>
              <br>
              <b-form-input @keydown.enter="refresh" type="text" :disabled="false" v-model="so.opt['target']">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- <b-row>
          <b-col md="4">
            <b-form-group>
              <label for="opt_ip_addr">IP Address</label>
              <b-form-input @keydown.enter="refresh" type="text" id="opt_ip_addr" v-model="so.opt['ip_addr']"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label for="opt_host">Host</label>
              <b-form-input @keydown.enter="refresh" type="text" id="opt_host" v-model="so.opt['host']"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label for="opt_name">Name</label>
              <b-form-input @keydown.enter="refresh" type="text" id="opt_name" v-model="so.opt['name']"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row> -->
        <b-row>
          <b-col md="6">
            <label for="ph_search_opt_type">Match Type</label>
            <b-form-group>
              <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" name="ph_search_opt_type">
                <b-form-radio value="and">[AND]:Match all</b-form-radio>
                <b-form-radio value="or">[OR]:Match at least one</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <label for="ph_search_opt_type">Group Name</label>
            <b-button variant="primary" @click="chainGroup = true">Select Group</b-button>
            <b-form-group>
              <b-form-input @keydown.enter="refresh" type="text" :disabled="false" v-model="group_name">
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-form-group class="float-right">
          <b-button size="sm" variant="success" @click="refresh"> Search </b-button>
          <b-button size="sm" variant="warning" @click="reset"> Reset </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> Close </b-button>
        </b-form-group>
      </b-card>
      <!-- detail search end -->

      <b-row>
        <b-col sm="12">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :disabled="so.adv" :text="so.skt || 'Search'" size="sm" variant="outline-secondary">
                <b-dropdown-item size="sm" @click="so.sk='target';so.skt='target'">Target</b-dropdown-item>
              </b-dropdown>
            </b-input-group-prepend>
            <b-form-input :disabled="so.adv" v-model="so.sv" @keyup.native.enter="refresh"></b-form-input>
            <b-input-group-append>
              <b-btn v-if="so.skt != 'action'" variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
              <b-btn variant="outline-secondary" @click="search_opt"><i class="fa" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i></b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col sm="6">
          <select v-model="limit" @change="$refs._list.refresh()">
            <option disabled value="20">Please select display count : Default 20</option>
            <option value="10">10</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </b-col>
      </b-row>
      <hr>

      <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found" :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage">
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <template slot="created_at" slot-scope="row">{{row.item.created_at | datetime}}</template>
        <!-- <template slot="info" slot-scope="row">{{row.item.agent|}}</template> -->
        <template slot="action" slot-scope="row">
          {{row.item.type != 'wmds' ? codes.agent_forgery[row.item.action] || row.item.action : "Changed"}}
          <b-button size="sm" v-if="row.item.type == 'wmds'" :variant="row.item.select ? 'danger' : 'success'" @click="row.item.select = true; detail(row.item)" >More</b-button>
        </template>
        <template slot="target" slot-scope="row">
          <span v-if="row.item.type.toUpperCase() == 'WMDS'">{{row.item.target}}</span>
          <span v-else-if="row.item.target_type">
              [{{row.item.target_type}}]
              <span v-if="row.item.action.toUpperCase() == 'RENAME' && row.item.old_path">
                {{row.item.old_path}} {{ row.item.old_hash ? `[${row.item.old_hash}]` : '' }}  ->
              </span>
              <span v-if="row.item.action.toUpperCase() == 'MOVE' && row.item.old_path">
                {{row.item.old_path}} {{ row.item.old_hash ? `[${row.item.old_hash}]` : '' }}  ->
              </span>
            <span v-else>
              {{ row.item.action.toUpperCase() == 'MODIFIED HASH' && row.item.old_path ? `${row.item.old_path} [${row.item.old_hash}] ->` : '' }}
            </span>
            {{row.item.path}} {{row.item.hash ? `[${row.item.hash}]` : ''}}
          </span>
          <span v-else>
            {{row.item.target ? row.item.target : row.item.path }}
          </span>
        </template>
      </b-table>

      <b-row>
        <b-col class="md-8">
          <b-pagination size="sm" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" prev-text="Prev" next-text="Next" />
        </b-col>
      </b-row>
    </b-card>
    <b-card v-if="model && model.id">
      <div slot="header">
				<strong>[#:{{model.id}}] {{model.target}}</strong>
        <span class="float-right">{{model.created_at | sdate}}</span>
			</div>
      <b-row>
        <b-col>
          <b-button style="width:100%" :variant="view_html ? 'success' : 'primary'" @click="view_html = !view_html" >View HTML : {{view_html ? 'On' : 'Off'}}</b-button>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col>
          (*)If the html reference is incorrect or the code is incorrect, the system may not be able to convert to the html page.
        </b-col>
      </b-row>
      <hr>
      <b-form-group>
        <pre v-if="!view_html" style="background-color:#f5f5f5; border:1px solid #ccc; padding:10px; border-radius: 5px;" id="ph_now_snapshot">{{model.now_snapshot}}</pre>
        <pre v-else v-html="model.now_snapshot" style="background-color:#f5f5f5; border:1px solid #ccc; padding:10px; border-radius: 5px;" id="ph_now_sanpshot_html"></pre>
      </b-form-group>
    </b-card>
    <!-- start connect group modal -->
    <b-modal title="Find then Group and Select" size="xl"  header-bg-variant="info" v-model="chainGroup" @ok="chainGroup = false" ok-variant="info">
      <group-List :auto_refresh="false" :enable_new="false" :view_detail="false" @select="setGroup"></group-List>
    </b-modal>

    <!-- <router-view @hide-parent="hideList($event)" @refresh="refresh()"></router-view> -->
  </div>
</template>

<script>
import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import custom from '@/custom';
import { Api } from '@/service';
import codes from '@/codes';
import vSelect from 'vue-select';
import groupList from '../Management/group/Group.List'

const default_opt = () => ({
  perPage: 10, //limit,
  currentPage: 1, //
  totalRows: 0,
  target : "agent",
  cmd : "search",
  request : "wsf",
  offset : 0,
  limit : 10,
  adv : false,
  sk : '', "sv" : '', "skt" : '', "opt" : { },
  body : {
    sort : [ { name : "group_id" }, { name : "id", op : "desc" } ]
  }
})

export default {
  components: { DatePicker, vSelect, groupList },
  props: ['is_main'],
  data : () => {
    return {
      action_list : [],
      chainGroup : false,
      codes,
      moment,
      group_name : '',
      custom,
      sync : { th : undefined, stop : false, interval : 15, enable : false },
      summaryData : { enable : 0, disable : 0 },
      //
      view_html : false,
      so : default_opt(),
      selected : '',
      limit : 20,
      search_type : '',
      action_type : '',
      model : {}
    }
  },
  computed: {
    rowCount: function() { return this.so.totalRows || 0; },
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      return [
        { key: 'id', label: '#', sortable: false, thStyle: 'width: 5%' },
        { key: 'type', label: 'Type', sortable: false, thStyle: 'width: 8%' },
        // { key: 'info', label: 'Type', sortable: false, thStyle: 'width: 8%' },
        { key: 'created_at', label: 'Time', sortable: false, thStyle: 'width: 15%' },
        { key: 'action', label: 'Action', sortable: false, thStyle: 'width: 10%' },
        { key: 'target', label: 'Target', sortable: false },
      ];
    },
  },
  methods: {
    set_op(k, v, equal=false) {
      if(equal) {
        return { name : k, value : v, op : '=' }
      }
      else if(['level', 'mode', 'group_id'].indexOf(k) > -1) {
        // console.log({ name : k, value : parseInt(v, 10), op : '=' })
        return { name : k, value : parseInt(v, 10), op : '=' };
      } else if(v == 'false' || v == 'true') {
        return { name : k, value : v === "false" ? false : true, op : '=' }
      }

      return { name : k, value : `%${v}%`, op : 'like' }
    },
    setGroup(item) {
      console.log("group info", item.groupname, item.id)
      this.so.opt['group_id'] = item.id
      this.group_name = item.groupname;
      this.chainGroup = false;
      this.refresh()
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;
      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt);
    },
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['created_at_ed'] = moment().add(1, "day").startOf('d');
        this.so.opt['match_type'] = 'and';

        this.so.sv = '';
      } else { this.reset(); }
    },
    reset() { this.so = default_opt(); this.group_name = undefined; this.refresh(); },
    // save(item) {
    //   let snapshot = [[item.target, item.depth, item.hash_selected.value]]
    //   Api.Manager_Call({target: 'integrity', cmd : 'update', body : { id : item.forgery_id, snapshot : snapshot, site_id : item.site_id, group_id : item.group_id }})
    // },
    async getAction() {
      let rs = await Api.Manager_Call('integrity.detect', 'action')
      this.action_list = rs.total > 0 ? rs.body : [];
    },
    refresh() { console.log('refresh'); this.$refs._list.refresh(); },
    getItems(ctx) { return this.load(ctx); },
    async load(ctx = {}) {
      let so = {
        target : 'integrity.detect', cmd : 'list',
        body : { sort : [{ name : "id", op : "desc"}], or : [], and : [] },
        offset : (this.so.currentPage-1 || 0) * this.limit, limit: this.limit, // 10 은 나중에 변수 처리해야함.
      }
      this.so.perPage = this.limit;
      // if(this.so.sk && (this.so.sv || '').trim()) { and.push({ name : this.so.sk, value : `%${this.so.sv}%`, op : 'like' }); }
      // if(this.search_type != '') { and.push({ name : "type", value : this.search_type, op : "=" }); }
      // if(this.so.skt == 'action') { and.push({ name : "action", value : this.action_type, op : "=" }); }
      // if(and.length) { so.body.and = and; }

      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      if(this.so.sk && (this.so.sv || '').trim()) { so.body.and.push(this.set_op(this.so.sk, this.so.sv, so)); }

      try {
        if(this.so.adv && this.so.opt) {
          var k = Object.keys(this.so.opt)
          for (let i = 0; i < k.length; i++) {
            if(k[i] == 'match_type') { continue; }
            let cond = undefined;

            switch (k[i]) {
              case 'created_at_sd':
                if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
                cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
                break;
              case 'created_at_ed':
                if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
                cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
                break;
              case 'updated_at_sd':
                if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
                cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
                break;
              case 'updated_at_ed':
                if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
                cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
                break;
              default:
                cond = this.set_op(k[i], this.so.opt[k[i]]);
                break;
            }
            if(cond.value == '%%' || cond.value === '') { continue; }
            if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
            else { so.body.or.push(cond) }
          }
        }
        this.getAction()
      } catch (e) { console.log(e) }
      return Api.Manager(so).then(rs => { this.so.totalRows = rs.total; this.model = rs.body; return rs.body; }).catch(e => console.log(e) );
    },
    async save() {
      if(!(this.model.title || '').trim()) { return this.$toastr.e('Title is required'); }
      if(!(this.model.content || '').trim()) { return this.$toastr.e('Content is required.'); }
      try {
        await Api.Manager_Call('integrity', this.model.id ? 'update' : 'insert', this.model)
        this.$toastr.s('Saved.', this.$route.name);this.$emit('refresh'); this.cancel();
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText) ; }
    },
    async detail(model) {
      console.log('result.vue', 'load item', model.id);
      try {
        let rs = await Api.Manager_Call('integrity.detect', 'detail', { id : model.id });
        if(!rs.error) {
          this.$toastr.i("loading", "done")
          this.model = rs.body;
        } else {
          this.$toastr.e("load failed", rs.reason)
        }

      } catch(e) { this.catch_msg(e) }

    },
    catch_msg(e) { console.log(e), this.$toastr.e(!e.data ? e : (e.data.message ? e.data.message : e.statusText)) },
  },
  created() { console.log('result.vue', 'created'); },
  destroyed() { console.log('result.vue', 'destroyed'); },
  mounted() { console.log('result.vue', 'mounted'); },
}
</script>
